import request from '@/utils/request'
export function siteOverview(siteId){
  return request({
    url: `/shanDongScreen/${siteId}/siteOverview`,
    method: 'get',
  })
}